var chunkToChildrenMap = {
	"49582": [
		71869,
		99215
	],
	"86081": [
		71869,
		99215
	],
	"87244": [
		93675,
		33332,
		75642
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));